import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryMetricsRangeArgs, SpaceliftMetrics } from "types/generated";

type GetChangeFailureRateRangeData = {
  metricsRange: Pick<SpaceliftMetrics, "changeFailureRateRange" | "hasRuns">;
};

export const GET_CHANGE_FAILURE_RATE_RANGE: TypedDocumentNode<
  GetChangeFailureRateRangeData,
  QueryMetricsRangeArgs
> = gql`
  query GetChangeFailureRateRange($input: MetricsInput) {
    metricsRange(input: $input) {
      changeFailureRateRange {
        value
        timestamp
      }
      hasRuns
    }
  }
`;
